module.exports = require("fontfaceobserver");


//////////////////
// WEBPACK FOOTER
// external "fontfaceobserver"
// module id = 4
// module chunks = 0